import { gtmSendEvent } from "@wojo/analytics";
import { Breadcrumbs } from "../../../components/breadcrumbs";
import styles from "./TourBreadcrumb.module.scss";

type TourBreadcrumbProps = {
    ancestors?: { href: string; name: string }[] | null;
    tourName?: string | null;
};

export const TourBreadcrumb: React.FC<TourBreadcrumbProps> = ({
    ancestors,
    tourName,
}) => {
    if (!tourName || !ancestors || ancestors.length === 0) {
        return null;
    }

    const breadcrumbItems = [
        ...ancestors.map((ancestor) => ({
            link: ancestor.href,
            text: ancestor.name,
        })),
        {
            link: "",
            text: tourName,
        },
    ];

    return (
        <Breadcrumbs
            className={styles.wrapper}
            innerClassName={styles.breadcrumbs}
            items={breadcrumbItems}
            onBreadcrumbItemClickCustomEvent={(text: string) => {
                gtmSendEvent({
                    event: "track",
                    ga4Tracking: {
                        ga4_object: "ELEMENT",
                        ga4_action: "CLICKED",
                        elementType: "breadCrumb",
                        elementID: text,
                        clickText: text,
                    },
                });
            }}
        />
    );
};
